import React from 'react';
import { Paper, Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { contragentSkeletonItems } from './ContragentInfo.mock';
import useStyles from './ContragentInfo.styles';

const ContragentInfoSkeleton = () => {
  const classes = useStyles();

  return (
    <Paper className={classes.skeletonContainer}>
      <Box pb={1}>
        {contragentSkeletonItems.map(({ height, width, marginBottom }, idx) => (
          /* eslint-disable-next-line react/no-array-index-key */
          <Skeleton key={idx} height={height} width={width} style={{ marginBottom }} />
        ))}
      </Box>
    </Paper>
  );
};

export default ContragentInfoSkeleton;
